export default __webpack_public_path__ + "static/media/Ethnic_wear.d60eebee.png";